/**
 * ログイン済みかどうか
 * @param auth
 */
export const isLogin = (auth) => !!(auth && auth.payload && auth.payload.id);
/**
 * ゲストかどうか
 * @param auth
 */
export const isGuest = (auth) => !isLogin(auth);
/**
 * ログインユーザーがクライアントかどうか
 * @param auth
 */
export const isClient = (auth) => { var _a; return isLogin(auth) && ((_a = auth.payload) === null || _a === void 0 ? void 0 : _a.type) === 'client'; };
/**
 * ログインユーザーがコンサルタントかどうか
 * @param auth
 */
export const isProfessional = (auth) => { var _a; return isLogin(auth) && ((_a = auth.payload) === null || _a === void 0 ? void 0 : _a.type) === 'professional'; };
/**
 * ログインユーザーがフリーコンサルかどうか
 * @param auth
 */
export const isFreeProfessional = (auth) => { var _a; return isLogin(auth) && ((_a = auth.payload) === null || _a === void 0 ? void 0 : _a.type) === 'free_professional'; };
